import React from 'react';

import { makeIconDef } from '../../makeIconDef';

export const CloseIconDef = {
  close: makeIconDef('close', {
    regular: () => <path d="M4 4L20 20M20 4L4 20" fill="none" stroke="currentColor" strokeWidth="2" />,
    filled: () => <path d="M4 4L20 20M20 4L4 20" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />,
  })
}